/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFloatingFilter, IFloatingFilterParams } from 'ag-grid-community';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ag-grid-field-text-floating-filter',
  templateUrl: './ag-grid-field-text-floating-filter.component.html',
  styleUrls: ['./ag-grid-field-text-floating-filter.component.scss'],
  standalone: false,
})
export class IrisAgGridFieldTextFloatingFilterComponent implements IFloatingFilter {
  private readonly destroyRef = inject(DestroyRef);

  readonly fieldControl = new FormControl<string>(null);

  readonly params = signal<IFloatingFilterParams>(null);
  readonly label = signal('');

  agInit(params: IFloatingFilterParams): void {
    this.params.set(params);
    this.label.set(params['label'] as string);

    this.handleControlChanges();
  }

  onParentModelChanged(parentModel: any): void {
    const parentModelValue = !parentModel ? null : parentModel.filter;
    if (parentModelValue !== this.fieldControl.value) {
      this.fieldControl.patchValue(parentModelValue);
    }
  }

  private handleControlChanges(): void {
    this.fieldControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(value => {
        this.params().parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('textFilter', value);
        });
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }
}
